import React, { Component } from 'react'
import { connect } from 'react-redux'

import { webSocket } from 'rxjs/webSocket'

import '@/companys/ttl/assets/styles/components/detail-center/options.scss'

import RadioOptions from '@/components/TabHeader/RadioOptions';
import Dropdown from '@/components/Dropdown/Dropdown';
import { Converter, formatFunctions, utilsFunction } from '@/helpers/functions';
import { stockActions } from "@/actions/trading/stock.action";
import { ACTION_TYPE } from '@/constants/w-socket';
import { getSafe } from '@/helpers/global';
import { closeConnection } from '@/helpers/functions/websocket'

import OptionsTableFun from './OptionsTableFun';
import LoadingLayer from '@/components/Spinner/LoadingLayer';






class Options extends Component {
    constructor(props) {
        super(props)
        this.state = {
           
            Radiogroup: [
                { label: 'market_all', value: 'all' },
                { label: 'market_options_call', value: 'call' },
                { label: 'market_options_put', value: 'put' },
            ],
            currentRadio: 'all',
            // ExpriyDate: [
            //     // { label: '2021-09', value: '2021-09' },
            //     // { label: '2021-11', value: '2021-11' },
            //     // { label: '2022-01', value: '2022-01' },
            //     // { label: '2022-02', value: '2022-02' },
            //     // { label: '2022-03', value: '2022-03' },
            //     // { label: '2022-04', value: '2022-04' },
            //     // { label: '2022-06', value: '2022-06' },
            //     // { label: '2022-09', value: '2022-09' }
            // ],
            ExpriyDate: [{label:'-------',value:''}],
            currentExpriyDate: '',
            Strike: [
                { label: this.props.language.market_all, value: 'all' },
                { label: '6', value: '6' },
                { label: '10', value: '10' },
                { label: '20', value: '20' },
                { label: '40', value: '40' },
            ],
            currentStrike: 'all',
            marketID: '',
            InstrumentID: '',
            OptionsTableFunData: [],
            deepOptionsData: [],
            load: true,
            OptionsTableKey:true
        }
        this.nowTime = Date.now()
        this.props.innerRef(this)
    }
    render() {
        const { language, marketParams } = this.props
        const { Radiogroup, currentRadio, ExpriyDate, Strike, OptionsTableFunData, load,OptionsTableKey } = this.state
        return (
            <div className='options' >
                <LoadingLayer load={load}></LoadingLayer>
                <div className='options-header'>
                    {/* <div className='options-header-target' >
                        {language.market_options_target + ":"}
                        {Converter.mappingWebSocketMarket(marketParams.marketID) + '.' + marketParams.stockCode + ' ' + marketParams.stockName}
                    </div> */}
                    <div className='options-header-strike' >
                        {language.market_options_strikes + ':'}
                        <Dropdown
                            selectedOptions={[Strike[0]]}
                            options={Strike}
                            innerRef={e => this.StrikeRef = e}
                            onChange={(v) => { this.handleStrike(v) }}
                        />
                    </div>
                    <div className='options-header-expriy-date' >
                        {language.market_options_expriy_date}
                        {ExpriyDate && <Dropdown
                            selectedOptions={[ExpriyDate[0]]}
                            options={ExpriyDate}
                            innerRef={e => this.ExpriyDateRef = e}
                            onChange={(v) => { this.handleExpriy(v) }}
                        />}
                    </div>
                    <div className='options-header-call-put' >
                        <RadioOptions options={Radiogroup} onChange={(opt) => this.handleRadiogroup(opt)} />
                    </div>
                    {/* <div className='options-header-more' >
                        {language.market_options_more}
                    </div> */}
                </div>
                <div className='options-table'>
                    <OptionsTableFun currentRadio={currentRadio} OptionsTableFunData={OptionsTableFunData} load={load} ref={e => this.optionsTableFunRef = e} key={OptionsTableKey} />
                </div>
            </div>
        )
    }
    componentDidMount() {
        const { marketParams } = this.props;
        let marketID = null
        let stockCode = null 
        if(this.props.marketParams.stockCode <= 10000 || this.props.marketParams.stockCode >= 29999){
            marketID = this.props.marketParams.marketID
            stockCode = this.props.marketParams.stockCode
        }else {
            marketID = this.props.NCmarketParams.NCmarketID
            stockCode = this.props.NCmarketParams.NCstockCode
        }
        this.setState({ marketID: marketID, InstrumentID: stockCode },
            () => { this.getData() })
    }
    componentDidUpdate(prevProps, prevState) {
        const { marketParams } = this.props;
        const { marketID, stockCode } = marketParams;
        // if(Number(10000)<=Number(stockCode) && Number(stockCode)<=20000 && marketID ==='HKEX' || !stockCode) return;
        if ((this.props.marketParams != prevProps.marketParams) ) {
            this.setState({ marketID: marketID, InstrumentID: stockCode ,OptionsTableKey:!this.state.OptionsTableKey},
                () => { 
                    if(this.state?.InstrumentID?.length >= 4){
                        this.getData() 
                    }
                })
        }
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return
        }
        this.nowTime = null
    }
    //两个数组对象比较，取不同值
    arrayRepeat(array1, array2) {
        var result = []
        for (var i = 0; i < array2.length; i++) {
            var obj = array2[i]
            var num = obj.destId
            var isExist = false
            for (var j = 0; j < array1.length; j++) {
                var aj = array1[j]
                var n = aj.destId
                if (n === num) {
                    isExist = true
                    break
                }
            }
            if (!isExist) {
                result.push(obj)
            }
        }
        return result
    }

    handleStrike = (v) => {
        this.setState({ currentStrike: v[0].value }, () => {
            this.handleFilterSelect()
        })
    }
    handleExpriy = (v) => {
        this.setState({ currentExpriyDate: v[0].value }, () => {
            this.handleFilterSelect()
        })
    }
    handleFilterSelect = () => {
        const { currentExpriyDate, currentStrike, deepOptionsData } = this.state;
        let EXrData = deepOptionsData.filter((item, index) => {
            return item.month == currentExpriyDate
        })
        let StrData = ''
        if (currentStrike == 'all') {
            StrData = EXrData
        } else {
            StrData = EXrData.slice(0, Number(currentStrike))
        }
        this.setState({ OptionsTableFunData: StrData }, () => {
            
        })
    }
    handleRadiogroup = (opt) => {
        this.setState({ currentRadio: opt.value })
        switch(opt.value){
            case 'all':
                setTimeout(() => {
                    this.optionsTableFunRef.tableHeaderLeftRef.current.scrollLeft = this.optionsTableFunRef.tableHeaderLeftRef.current.scrollWidth
                    this.optionsTableFunRef.tableBodyLeftRef.current.scrollLeft = this.optionsTableFunRef.tableBodyLeftRef.current.scrollWidth
                    this.optionsTableFunRef.tableFooterLeftRef.current.scrollLeft = this.optionsTableFunRef.tableFooterLeftRef.current.scrollWidth
                });
                break;
        }
    }

    getData = () => {
        let { marketID, InstrumentID } = this.state
        const { language } = this.props
        let _this = this
        this.setState({ load: true, deepOptionsData: [], OptionsTableFunData: [], ExpriyDate: [] }, () => {
            if(!InstrumentID){
                this.setState({load:false,ExpriyDate:[{label:'-------',value:null}],OptionsTableFunData:[]})
                return
            }

            
            let ExpriyDate = []
            let timeout = setTimeout(() => {
                this.setState({load:false,ExpriyDate:[{label:'-------',value:null}],OptionsTableFunData:[]})
                return
            }, 6000);
            this.props.getSeriesProduct({ language: language.lang, instrumentID: InstrumentID }, res => {
                if (res) {
                    clearTimeout(timeout)
                    let OptionsTableFunData = []
                    this.setState({ load: false })
                    if(res.result?.seriesProducts[0]?.months){
                        res.result.seriesProducts[0].months.forEach((item, index) => {
                            ExpriyDate.push({ label: item.month, value: item.month })
                            item.strikePrice.forEach((sitem, sindex) => {
                                let strikePrice = (Number(sitem.strikePrice)).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 })
                                OptionsTableFunData.push({ center: strikePrice, month: item.month, call: sitem.call, put: sitem.put })
                            })
                        })
                    }else {
                        ExpriyDate = [{label:'-------',value:null}]
                    }
                    this.setState({ OptionsTableFunData, ExpriyDate, deepOptionsData: OptionsTableFunData, currentExpriyDate: ExpriyDate[0].value }, () => {
                        let {deepOptionsData} = this.state
                        if(deepOptionsData.length != 0){
                            deepOptionsData.forEach((item, index) => {
                                this.props.getOptions({ type: ACTION_TYPE.GREEK_OPTIONS, exchangeID: marketID, key: item.call }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        deepOptionsData[index].call_delta = getSafe(() => res.delta, '-')
                                        deepOptionsData[index].call_theta = getSafe(() => res.theta, '-')
                                        deepOptionsData[index].call_gamma = getSafe(() => res.gamma, '-')
                                        deepOptionsData[index].call_vega = getSafe(() => res.vega, '-')
                                        deepOptionsData[index].index = index
                                        this.setState({  deepOptionsData }, () => {
                                        })
                                    }
                                })
                                this.props.getOptions({ type: ACTION_TYPE.STATISTICS, exchangeID: marketID, key: item.call }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        deepOptionsData[index].call_price = getSafe(() => Number(res.last).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 }), '-')
                                        deepOptionsData[index].call_open = getSafe(() => Number(res.open).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 }) , '-')
                                        deepOptionsData[index].call_volume = getSafe(() => Number(res.volume).toLocaleString(undefined, { 'minimumFractionDigits': 0, 'maximumFractionDigits': 0 }) , '-')
                                        deepOptionsData[index].call_turnover = getSafe(() => Number(res.turnover).toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 }), '-')
                                        this.setState({ deepOptionsData }, () => {
                                        })
                                    }
                                })
                                this.props.getOptions({ type: ACTION_TYPE.BEST_BID_ASK, exchangeID: marketID, key: item.call }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        deepOptionsData[index].call_ask_price = getSafe(() => Number(res.bestAsk.price).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 }) , '-')
                                        deepOptionsData[index].call_ask_volume = getSafe(() => Number(res.bestAsk.qty).toLocaleString(undefined, { 'minimumFractionDigits': 0, 'maximumFractionDigits': 0 }) , '-')
                                        deepOptionsData[index].call_bid_price = getSafe(() => Number(res.bestBid.price).toLocaleString(undefined, { 'minimumFractionDigits': 0, 'maximumFractionDigits': 0 }) , '-')
                                        deepOptionsData[index].call_bid_volume = getSafe(() => Number(res.bestBid.qty).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 })  , '-')
                                        this.setState({ deepOptionsData}, () => {
                                        })
                                    }
                                })
                                // this.props.getOptions({ type: ACTION_TYPE.CLOSING_PRICE, exchangeID: marketID, key: item.call }, res => {
                                //     if(res.rtnCode) return
                                //     if (this.nowTime && res) {
                                //         let quote = {}
                                //         let quoteData = {}
                                //         // this.state.deepOptionsData[index].call_closingPrice = getSafe(() => res.closingPrice, '-')
                                //         quote.prev = res.closingPrice
                                //         if (deepOptionsData[index].call_price && res.closingPrice) {
                                //             quote.last = deepOptionsData[index].call_price
                                //             quoteData = Converter.computeQuoteData(quote)
                                //             deepOptionsData[index].call_change = quoteData.changeValue + quoteData.changePercent
                                //             deepOptionsData[index].call_change_classStyle = quoteData.classStyle
                                //         }else {
                                //             deepOptionsData[index].call_change = '-'
                                //             deepOptionsData[index].call_change_classStyle = ''
                                //         }
                                //         this.setState({ deepOptionsData }, () => {
                                //         })
                                //     }
                                // })
                                this.props.getOptions({ type: ACTION_TYPE.IMPLIED_VOLATILITY, exchangeID: marketID, key: item.call }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        if(res.iv){
                                           deepOptionsData[index].call_iv =  (Number(res.iv * 100).toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 }))  +    '%'
                                        }else {
                                            deepOptionsData[index].call_iv = '-'
                                        }
                                        this.setState({ deepOptionsData }, () => {
                                        })
                                    }
                                })
    
                                //////////////////////////////////////////////////////////
                                //   .toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 })
                                this.props.getOptions({ type: ACTION_TYPE.GREEK_OPTIONS, exchangeID: marketID, key: item.put }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        deepOptionsData[index].put_delta = getSafe(() => res.delta, '-')
                                        deepOptionsData[index].put_theta = getSafe(() => res.theta, '-')
                                        deepOptionsData[index].put_gamma = getSafe(() => res.gamma, '-')
                                        deepOptionsData[index].put_vega = getSafe(() => res.vega, '-')
                                        this.setState({ deepOptionsData }, () => {
                                        })
                                    }
                                })
                                this.props.getOptions({ type: ACTION_TYPE.STATISTICS, exchangeID: marketID, key: item.put }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        deepOptionsData[index].put_price = getSafe(() => Number(res.last).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 }) , '-')
                                        deepOptionsData[index].put_open = getSafe(() => Number(res.open).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 }), '-')
                                        deepOptionsData[index].put_volume = getSafe(() => Number(res.volume).toLocaleString(undefined, { 'minimumFractionDigits': 0, 'maximumFractionDigits': 0 }) , '-')
                                        deepOptionsData[index].put_turnover = getSafe(() => Number(res.turnover).toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 }) , '-')
                                        this.setState({ deepOptionsData }, () => {
                                        })
                                    }
                                })
                                this.props.getOptions({ type: ACTION_TYPE.BEST_BID_ASK, exchangeID: marketID, key: item.put }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        deepOptionsData[index].put_ask_price = getSafe(() => Number(res.bestAsk.price).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 }) , '-')
                                        deepOptionsData[index].put_ask_volume = getSafe(() => Number(res.bestAsk.qty).toLocaleString(undefined, { 'minimumFractionDigits': 0, 'maximumFractionDigits': 0 }) , '-')
                                        deepOptionsData[index].put_bid_price = getSafe(() => Number(res.bestBid.price).toLocaleString(undefined, { 'minimumFractionDigits': 3, 'maximumFractionDigits': 3 }) , '-')
                                        deepOptionsData[index].put_bid_volume = getSafe(() => Number(res.bestBid.qty).toLocaleString(undefined, { 'minimumFractionDigits': 0, 'maximumFractionDigits': 0 }) , '-')
                                        this.setState({ deepOptionsData }, () => {
                                        })
                                    }
                                })
                                // this.props.getOptions({ type: ACTION_TYPE.CLOSING_PRICE, exchangeID: marketID, key: item.put }, res => {
                                //     if(res.rtnCode) return
                                //     if (this.nowTime && res) {
                                //         let quote = {}
                                //         let quoteData = {}
                                //         // this.state.deepOptionsData[index].put_closingPrice = getSafe(() => res.closingPrice, '-')
                                //         quote.prev = res.closingPrice
                                //         if (deepOptionsData[index].put_price && res.closingPrice) {
                                //             quote.last = deepOptionsData[index].put_price
                                //             quoteData = Converter.computeQuoteData(quote)
                                //             deepOptionsData[index].put_change = quoteData.changeValue + quoteData.changePercent
                                //             deepOptionsData[index].put_change_classStyle = quoteData.classStyle
                                //         }else {
                                //             deepOptionsData[index].put_change = '-'
                                //             deepOptionsData[index].put_change_classStyle = ''
                                //         }
                                //         this.setState({ deepOptionsData }, () => {
                                //         })
                                //     }
                                // })
                                this.props.getOptions({ type: ACTION_TYPE.IMPLIED_VOLATILITY, exchangeID: marketID, key: item.put }, res => {
                                    if(res.rtnCode) return
                                    if (this.nowTime && res) {
                                        if(res.iv){
                                            deepOptionsData[index].put_iv =  (Number(res.iv * 100).toLocaleString(undefined, { 'minimumFractionDigits': 2, 'maximumFractionDigits': 2 }))
                                        }else {
                                            deepOptionsData[index].put_iv = '-'
                                        }
                                        this.setState({ deepOptionsData }, () => {
                                        })
                                    }
                                })
                            })
                        }
                        let EXOptionsTableFunData = deepOptionsData.filter((item, index) => {
                            return item.month === ExpriyDate[0].value
                        })
                        this.setState({ OptionsTableFunData: EXOptionsTableFunData }, () => {
                            _this.optionsTableFunRef.tableBodyLeftRef.current.scrollLeft = _this.optionsTableFunRef.tableBodyLeftRef.current.scrollWidth
                        })
                    })
                }
            })
        })






    }

}

export default connect(state => ({
    language: state.app.language,
    marketParams: state.trade.marketParams,
    NCmarketParams:state.trade.NCmarketParams,
}),
    dispatch => ({
        getOptions: (p, res) => stockActions.getOptionsAction(p, res), //GREEK_OPTIONS
        getSeriesProduct: (p, res) => stockActions.getSeriesProductAction(p, res)  //  seriesProductEnquiry
    }))(Options)